import React from "react";
import { Form } from "react-bootstrap";
import "./Dropdown.css";

const DropDown = props => {
  return (
    <>
      <Form.Group className={props.className}>
        <Form.Label htmlFor={props.id}> {props.label}</Form.Label>
        <Form.Control
          placeholder={props.placeholder}
          id={props.id}
          style={{ borderColor: props.style }}
          onChange={props.onChange}
          value={props.value}
          as={props.asProperty}
          className={props.className}
          disabled={props.readOnly}
        >
          <option hidden={props.hidden}>{props.text}</option>
          {props.map}
        </Form.Control>
      </Form.Group>
    </>
  );
};

export default DropDown;
